import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { notSendToken } from '../interceptors/refresh-token.interceptor';
import { TGetAddressResponse } from '@models/address.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  private URL: string = environment.rootUrl;
  private zipcodeURL = 'https://codigospostales.herokuapp.com/postal_code/suburbs';

  constructor(
    private http: HttpClient,
  ) { }

  public getAddresses(): Promise<TGetAddressResponse> {
    return firstValueFrom(this.http.get<TGetAddressResponse>(`${this.URL}/address`));
  }

  public lookUpZipcode(zipcode: string): Promise<any> {
    try {
      return this.http.get(`${this.zipcodeURL}/${zipcode}`, { context: notSendToken(), headers: { Authorization: 'Bearer b4mbum0b1l3' } }).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public addAddress(address: any): Promise<any> {
    try {
      return this.http.post(`${this.URL}/address`, address).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public updateAddress(id: string, address: any): Promise<any> {
    try {
      return this.http.put(`${this.URL}/address/${id}`, address).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public setAsDefault(id: string): Promise<any> {
    try {
      return this.http.put(`${this.URL}/address/default/${id}`, {}).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public deleteAddress(address: number): Promise<any> {
    try {
      return this.http.delete(`${this.URL}/address/${address.toString()}`).toPromise();
    } catch (error: any) {
      return error;
    }
  }

}
